export enum ButtonStatus {
  ACTIVE,
  LOADING,
  ERROR,
  SUCCESS,
}
